import { Modal, Button } from "../../../components/ui";
import { strings } from "../../../strings/strings";

const ViewHcpModal = ({ isOpen, onClose, hcp }) => {
  const footer = (
    <div className="flex justify-end">
      <Button variant="outline" onClick={onClose}>
        {strings.close}
      </Button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={strings.hcpDetails} size="lg" footer={footer}>
      <div className="mb-4">
        <h3 className="text-base font-semibold text-secondary bg-gray-50 rounded-lg p-3 border border-gray-200">
          <span className="mr-2">{strings.name} :</span>
          <span className="mr-2">{hcp?.first_name || "-"}</span>
          {hcp?.last_name || ""}
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Detail label={strings.refferalCode} value={hcp?.referral_code} />
        <Detail label={strings.email} value={hcp?.email} />

        <Detail
          label={strings.mobileNumber2}
          value={hcp?.mobile_code && hcp?.mobile_number ? `${hcp.mobile_code} ${hcp.mobile_number}` : "-"}
        />

        <Detail label={strings.hospitalName} value={hcp?.hospital_name} />
        <Detail label={strings.country} value={hcp?.country} />
        <Detail label={strings.createdBy} value={hcp?.created_by_role} />
      </div>
    </Modal>
  );
};

const Detail = ({ label, value }) => (
  <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
    <p className="text-xs text-gray-500">{label}</p>
    <p className="text-sm text-secondary mt-1 break-words font-medium">{value || "-"}</p>
  </div>
);

export default ViewHcpModal;
